import { Injectable } from '@angular/core';
import {
  cancelCall,
  disableBackdrop,
  enableBackdrop,
  finalizeCall,
  initializeCall,
} from '@epicuro-next/state/connect-state';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { tap } from 'rxjs/operators';

import { ConnectVideoService } from '../services/connect-video.service';

@Injectable()
export class ConnectVideoEffects {
  constructor(
    private actions$: Actions,
    private service: ConnectVideoService,
  ) {}

  public initializeCall$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(initializeCall),
        tap(() => {
          this.service.initializeCall();
        }),
      ),
    {
      dispatch: false,
    },
  );

  public finalizeCall$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(finalizeCall, cancelCall),
        tap(() => {
          this.service.finalizeCall();
        }),
      ),
    {
      dispatch: false,
    },
  );

  public setScreenShareStarted$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(disableBackdrop),
        tap(() => {
          this.service.disableBackdrop();
        }),
      ),
    {
      dispatch: false,
    },
  );

  public setScreenShareStopped$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(enableBackdrop),
        tap(() => {
          this.service.enableBackdrop();
        }),
      ),
    {
      dispatch: false,
    },
  );
}
